import React, { useState } from 'react';
import { Input, Tag, message, Spin } from 'antd';
import REGEX from '../../utils/regex';
import { useTranslation } from 'react-i18next';
import { TAG_LIST_INPUT } from './translationValues';

const NAMESPACES = ['TAG_LIST_INPUT'];

const TagListInput = ({
  title,
  tags = [],
  originalTags = [],
  onAdd,
  onRemove,
  placeholder,
  disabled = false,
  loading = false,
}) => {
  const [inputValue, setInputValue] = useState('');
  const { t } = useTranslation(NAMESPACES);

  const handleAdd = async () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
      if (!REGEX.EMAIL.test(trimmed)) {
          message.error(`${t(
              TAG_LIST_INPUT.INVALID_EMAIL_ADDRESS.key,
              TAG_LIST_INPUT.INVALID_EMAIL_ADDRESS.value,
          )}`);
          return;
      }
    try {
      await onAdd(trimmed);
      setInputValue('');
    } catch (err) {
      console.error(err.message || 'Failed to add address');
    }
  };

    return (
        <div style={{ marginBottom: 16 }}>
            {title && <div style={{ fontWeight: 600, marginBottom: 6 }}>{title}</div>}
            <div
                style={{
                    border: '1px solid #d9d9d9',
                    borderRadius: 6,
                    padding: 8,
                    minHeight: 40,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 6,
                    background: disabled ? '#f9f9f9' : 'white',
                }}
            >
                {originalTags.map((email) => (
                    <Tag key={`orig-${email}`} color="default" style={{ background: '#e0e0e0', color: '#545050', cursor: 'not-allowed' }}>
                        {email}
                    </Tag>
                ))}
                {tags.map((email) => (
                    <Tag
                        key={email}
                        closable
                        onClose={() => onRemove(email)}
                        color="#df4c35"
                    >
                        {email}
                    </Tag>
                ))}
                {!disabled && (
                    <Input
                        size="small"
                        bordered={false}
                        style={{ width: 200, flex: 1, minWidth: 120 }}
                        placeholder={placeholder || `${t(
                            TAG_LIST_INPUT.TYPE_EMAIL_PLACEHOLDER.key,
                            TAG_LIST_INPUT.TYPE_EMAIL_PLACEHOLDER.value,
                        )}`}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onPressEnter={() => handleAdd()}
                    />
                )}
                {loading && <Spin size="small" />}
            </div>
        </div>
    );
};

export default TagListInput;
